import { Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Loading from "../components/Loading";
import Index from "../pages/Index";
import {
  NotFound,
  Games,
  ProgressPage,
  About,
  Privacy,
  Terms,
  Contact,
  MemoryMatch,
  SimonSays,
  QuickMath,
  SpotDifference,
  WordSearch,
  StroopTest,
  TowerOfHanoi,
  WhackAMole,
  NumberSequences,
  AnagramSolver,
  MazeSolver,
  ReactionTest,
  PatternMemory,
  NBack,
  WordPairs,
  MentalRotation,
  CrosswordPuzzle,
  SlidingPuzzle,
  Sudoku,
  WordChain,
  TaskSwitching,
  SequenceRecall,
  DualNBack,
  Nonograms,
} from "./lazyRoutes";

const AppRoutes = () => (
  <Suspense fallback={<Loading />}>
    <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/games" element={<Games />} />
      <Route path="/progress" element={<ProgressPage />} />
      <Route path="/about" element={<About />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/games/memory-match" element={<MemoryMatch />} />
      <Route path="/games/simon-says" element={<SimonSays />} />
      <Route path="/games/quick-math" element={<QuickMath />} />
      <Route path="/games/spot-difference" element={<SpotDifference />} />
      <Route path="/games/word-search" element={<WordSearch />} />
      <Route path="/games/stroop-test" element={<StroopTest />} />
      <Route path="/games/tower-hanoi" element={<TowerOfHanoi />} />
      <Route path="/games/whack-a-mole" element={<WhackAMole />} />
      <Route path="/games/number-sequences" element={<NumberSequences />} />
      <Route path="/games/anagram-solver" element={<AnagramSolver />} />
      <Route path="/games/maze-solver" element={<MazeSolver />} />
      <Route path="/games/reaction-test" element={<ReactionTest />} />
      <Route path="/games/pattern-memory" element={<PatternMemory />} />
      <Route path="/games/n-back" element={<NBack />} />
      <Route path="/games/word-pairs" element={<WordPairs />} />
      <Route path="/games/mental-rotation" element={<MentalRotation />} />
      <Route path="/games/crossword" element={<CrosswordPuzzle />} />
      <Route path="/games/sliding-puzzle" element={<SlidingPuzzle />} />
      <Route path="/games/sudoku" element={<Sudoku />} />
      <Route path="/games/word-chain" element={<WordChain />} />
      <Route path="/games/task-switching" element={<TaskSwitching />} />
      <Route path="/games/sequence-recall" element={<SequenceRecall />} />
      <Route path="/games/dual-n-back" element={<DualNBack />} />
      <Route path="/games/nonograms" element={<Nonograms />} />
      {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Suspense>
);

export default AppRoutes;
